import { Lock } from "lucide-react";
import * as React from "react";

import shared from "@/shared/components/invocationSpec/invocationSpec.module.css";

import styles from "./IngestionRuleForm.module.css";

export const UPLOADED_FILE_INPUT_TITLE =
  "The uploaded file that matched this rule";

/**
 * The input every ingestion is handed first, shown where the rows go but not
 * one of them: the managed trigger adds it, so it is neither editable nor
 * removable, and the rule does not store it.
 */
export function UploadedFileInput() {
  const titleId = React.useId();
  return (
    <div
      className={shared.row}
      data-testid="pinned-uploaded-file"
      aria-readonly="true"
    >
      <section className={shared.contents} aria-labelledby={titleId}>
        <header className={shared.heading}>
          <h5 id={titleId} className={shared.rowTitle}>
            {UPLOADED_FILE_INPUT_TITLE}
          </h5>
          <p className={shared.hint}>Always passed as the first input.</p>
        </header>
      </section>
      <Lock
        aria-label="Always included"
        size={16}
        className={styles.pinnedIcon}
      />
    </div>
  );
}
